import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLElement> & {
  asChild?: boolean
}

const Section = forwardRef<HTMLElement, SectionProps>(({ asChild, className, ...props }, ref) => {
  const Component = asChild ? Slot : 'section'
  return <Component ref={ref} className={cn('relative', className)} {...props} />
})

export default Section
